import { create } from 'zustand'

export const useUpdateDataAdministracion = create(set => ({
  updateData: false,
  setUpdateData: value => set(() => ({ updateData: value }))
}))

export const useAdministracionTabs = create(set => ({
  activeTab: '',
  setActiveTab: tab => set(() => ({ activeTab: tab }))
}))

export const useSummaryMovementsOverrides = create(set => ({
  overrides: {},
  setOverride: movement =>
    set(state => {
      if (!movement || typeof movement?.id !== 'number') return state
      return {
        overrides: {
          ...state.overrides,
          [movement.id]: movement
        }
      }
    }),
  clearOverride: movementId =>
    set(state => {
      if (!movementId) return state
      const next = { ...state.overrides }
      delete next[movementId]
      return { overrides: next }
    })
}))

export const useIntegrationStatus = create(set => ({
  status: null,
  isLoading: false,
  error: null,
  setStatus: status => set({ status, error: null }),
  setLoading: isLoading => set({ isLoading }),
  setError: error => set({ error, isLoading: false })
}))
